import { MutationTuple, useMutation } from '@apollo/client';
// Api
import {
  UPDATE_CAMPAIGN_DEADLINES,
  UPDATE_CAMPAIGN_OWNERSHIP,
} from 'api/campaignV2/mutations';
// Types
import {
  UpdateCampaignDeadlines,
  UpdateCampaignDeadlinesVariables,
} from 'api/campaignV2/types/UpdateCampaignDeadlines';
import {
  UpdateCampaignOwnership,
  UpdateCampaignOwnershipVariables,
} from 'api/campaignV2/types/UpdateCampaignOwnership';

type UseCampaignManagementResult = {
  updateCampaignDeadlines: MutationTuple<
    UpdateCampaignDeadlines,
    UpdateCampaignDeadlinesVariables
  >[0];
  loadingUpdateCampaignDeadlines: boolean;
  updateOwnership: MutationTuple<
    UpdateCampaignOwnership,
    UpdateCampaignOwnershipVariables
  >[0];
  updateOwnershipLoading: boolean;
};

export const useCampaignManagement = (): UseCampaignManagementResult => {
  const [updateCampaignDeadlines, { loading: loadingUpdateCampaignDeadlines }] =
    useMutation<UpdateCampaignDeadlines, UpdateCampaignDeadlinesVariables>(
      UPDATE_CAMPAIGN_DEADLINES
    );

  const [updateOwnership, { loading: updateOwnershipLoading }] = useMutation<
    UpdateCampaignOwnership,
    UpdateCampaignOwnershipVariables
  >(UPDATE_CAMPAIGN_OWNERSHIP);

  return {
    updateCampaignDeadlines,
    loadingUpdateCampaignDeadlines,
    updateOwnership,
    updateOwnershipLoading,
  };
};
